import {
  AfterContentInit,
  Component, ElementRef,
  EventEmitter,
  inject,
  Input,
  NO_ERRORS_SCHEMA,
  OnInit,
  Output, ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import {
  includes,
  remove,
  get,
  set,
  forEach,
  replace,
  startsWith,
  isArray,
  join,
  camelCase,
  trim,
  some, every, find, cloneDeep, isEqual
} from 'lodash-es';
import { isDefined, runtimeEventManager, replace as _replace, $invokeWatchers, toBoolean } from "@wm/core";
import { BaseComponent, SearchComponent, WmsDialogComponent, BindDialogUiComponent } from '@wms/components';
import {
  findValueOf, isEmptObject, MarkupManagerService, onAccessRolesChange, StudioUtils,
  updateUrlParams, WIDGET_CONSTANTS
} from "@wms/core";
import { PageWsService, PageWorkspaceComponent } from "@wms/workspace";
import { PropertiesTemplateComponent } from './properties-template/properties-template.component';
import { propFactory as PropertiesFactory, nameIdMap } from "@wm/components-base";
import {
  DialogService,
  BindVariableService,
  NotificationService,
  PreferenceService, PrefabService
} from "@wms/services";
import { SecurityService } from '@wms/settings/security'
import { WmCommandProvider } from "@wms/app";
import { PropertyController } from "./propertyController";
import { CanvasDomService, WidgetPropertiesProvider } from "@wms/design-container";
import { CapitalizePipe } from "@wm/components-base";
import { BaseVariableService, VariableCrudManagerService } from '@wms/variables';
import { WmsIconSelectorComponent } from "@wms/app/components/wms-icon-selector/wms-icon-selector.component";
import { LiveWidgetSettingsService } from '@wms/services';
import { WmsWidgetHelpDirective } from './wms-widget-help/wms-widget-help.directive';
import { WmsExpressionErrorDirective } from '../directives/wms-expression-error/wms-expression-error.directive';
import { CommonWidgetDirective } from "@wms/directives";
import {
  PropertyTemplatesListComponent
} from "./properties-template/property-templates-list/property-templates-list.component";
import {TemplateService} from "@wms/app/properties-panel/properties-template/template-service";
import { VersionManagerPipe } from "../core/utils/version-manager-pipe";
import {ActivatedRoute, Router} from "@angular/router";

let datasetWidgets = ['wm-table', 'wm-list', 'wm-liveform', 'wm-livefilter', 'wm-livetable', 'wm-select', 'wm-checkboxset', 'wm-radioset', 'wm-chart', 'wm-search', 'wm-menu', 'wm-nav', 'wm-chips', 'wm-calendar'];
let HIDE_WIDGET_CLASS = 'hidden';

@Component({
  selector: 'wms-properties-panel',
  standalone: true,
  imports: [
    CommonModule,
    TabsModule,
    FormsModule,
    SearchComponent,
    PropertiesTemplateComponent,
    WmsDialogComponent,
    BindDialogUiComponent,
    CapitalizePipe,
    WmsIconSelectorComponent,
    WmsWidgetHelpDirective,
    WmsExpressionErrorDirective,
    CommonWidgetDirective,
    VersionManagerPipe
],
  providers: [],
  templateUrl: './properties-panel.component.html',
  styleUrls: ['./properties-panel.component.less'],
  schemas: [NO_ERRORS_SCHEMA]
})

export class PropertiesPanelComponent extends BaseComponent implements AfterContentInit, OnInit {
  @ViewChild('propertiesPanelComp', { read: ElementRef, static: true }) propPanelComp: ElementRef<HTMLElement>;
  widgetPropertyChanged: boolean = false;
  group: any;
  boolCount = 0;
  activeTab = 'DESIGN';
  hiddenElementsExist: boolean = false;
  pageParamTypes = ['string', 'integer', 'boolean', 'date'];
  bindVariableService: BindVariableService;
  baseVariableService: BaseVariableService;
  varManagerService: VariableCrudManagerService;

  @Input() activeWidget: any;
  @Input() activeMarkupEl: JQuery<HTMLElement> | undefined | null;
  @Output() onAdvancedSettingsClick = new EventEmitter<any>();

  propertyGroups: any = [];
  advancedPropertyGroup: any = [];
  public dialogService: DialogService

  shadowProperties: any = {}
  selectedWidgetsCount: number = 0;

  // TODO: replace with original project
  project: any;

  datePatterns = [
    "yyyy-MM-dd",
    "yyyy-M-dd",
    "M-dd-yyyy",
    "MM-dd-yy",
    "yyyy, dd MMMM",
    "yyyy, MMM dd",
    "MM/dd/yyyy",
    "M/d/yyyy",
    "MM/YY",
    "YY/MM",
    "MM/YYYY",
    "YYYY/MM",
    "EEE, dd MMM yyyy",
    "EEE MMM dd yyyy",
    "EEEE, MMMM dd, yyyy",
    "timestamp"
  ]

  timePatterns = [
    "HH:mm:ss",
    "HH:mm",
    "hh:mm:ss",
    "hh:mm",
    "hh:mm a",
    "H:m:s",
    "h:m:s",
    "timestamp"
  ]

  calendarPatterns = [
    "dd/MM/yyyy",
    "yyyy-MM-dd",
    "yyyy-M-dd",
    "M-dd-yyyy",
    "M/d/yyyy",
    "MM/dd/yyyy",
    "yyyy, MMM dd",
    "yyyy, dd MMMM",
    "yyyy-MM-ddTHH:mm:ss",
    "MM-dd-yy hh:mm:ss a",
    "MM-dd-yy hh:mm:ss a Z",
    "dd-MMM-yyyy HH:mm:ss",
    "yyyy-MM-dd HH:mm",
    "yyyy-MM-dd HH:mm:ss:sss",
    "yyyy-MM-dd hh:mm a",
    "yyyy-MM-dd hh:mm:ss a",
    "yyyy-MM-dd hh:mm:ss:sss Z",
    "yyyy-MM-dd hh:mm:ss:sss a",
    "EEE MMM dd hh:mm:ss Z yyyy",
    "EEE, dd MMM yyyy HH:mm:ss Z",
    "EEEE, MMMM dd, yyyy",
    "timestamp",
    "MMM, yyyy",
    "UTC"
  ]
  private pageWs: PageWorkspaceComponent;
  public markupManager: MarkupManagerService;
  public pageWsService: PageWsService;
  private wmCommand: WmCommandProvider;
  private widgetProperties: WidgetPropertiesProvider;
  iconBoundToProperty: any;
  liveWidgetSettingsService: LiveWidgetSettingsService;
  securityService: SecurityService;
  preferenceService:PreferenceService;

  protected isMobileApplicationType: boolean;
  protected isPrefabType: boolean;
  protected prefabService: PrefabService;
  notificationService: NotificationService;

  constructor(private canvasDomService: CanvasDomService, private router: Router, private route: ActivatedRoute) {
    super();
    this.pageWs = inject(PageWorkspaceComponent);
    this.markupManager = inject(MarkupManagerService);
    this.dialogService = inject(DialogService);
    this.pageWsService = inject(PageWsService);
    this.wmCommand = inject(WmCommandProvider);
    this.widgetProperties = inject(WidgetPropertiesProvider);
    this.bindVariableService = inject(BindVariableService);
    this.baseVariableService = inject(BaseVariableService);
    this.varManagerService = inject(VariableCrudManagerService);
    this.liveWidgetSettingsService = inject(LiveWidgetSettingsService);
    this.securityService = inject(SecurityService);
    this.preferenceService = inject(PreferenceService);

    this.project = this.projectService.getDetails();
    this.isMobileApplicationType = this.projectService.isMobileApplicationType();
    this.isPrefabType = this.projectService.isPrefabType();
    this.prefabService = inject(PrefabService);
    this.notificationService = inject(NotificationService);

    this.registerDestroyListener.add(this.eventManager.widgetPropChangedObservable().subscribe((data: boolean) => {
      this.widgetPropertyChanged = data;
      this.pageWsService.setWidgetPropertyChangedFlg(data);
    }));

    this.registerDestroyListener.add(runtimeEventManager.on('update-widget-property').subscribe((data) =>
      this.shadowPropertyChange(data.prop, data.value, undefined, undefined, undefined, data.isVariableEvt)
    ));

    this.registerDestroyListener.add(runtimeEventManager.on('update-widget-properties').subscribe((data) => {
      forEach(data.propertiesChanged, (property) => {
        this.shadowPropertyChange(property, data.shadowProperties[property]);
      })
    }
    ));

    this.registerDestroyListener.add(runtimeEventManager.on('update-shadow-props').subscribe((data) => {
      this.shadowProperties = data;
    }
    ));

    //updates hiddenElementsExist variable on every page ready
    this.registerDestroyListener.add(runtimeEventManager.on('page-ws-ready').subscribe(() => {
      this.updateStateOfHiddenEle();
    }
    ));

    this.registerDestroyListener.add(this.eventManager.widgetSelectionCountObservable().subscribe((count) => {
      this.selectedWidgetsCount = count;
    }));

    runtimeEventManager.setService('PropertyPanel', this);

    runtimeEventManager.on('initPropertyGroups').subscribe(() => this.initPropertyGroups());
  }

  ngAfterContentInit() {
    this.initPropertyGroups();
    this.initPropertyGroups(true);
    setTimeout(() => {
      this.setWidgetGroupActive();
    })
  }

  ngOnInit() {
    this.eventManager.switchPropPanelAsObservable().subscribe((index: number) => {
       const elem =  this.propPanelComp?.nativeElement?.querySelector(`a[id='${this.propertyGroups[index || 0]?.name}-link']`) as HTMLElement;
       if(elem) {
         elem.click();
       }
    });
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();

  }

  widgetFactory() {
    return this.widgetProperties.getGroups().filter((group) => {
      // enable mywidgets section for prism projects
      let hasAccess_group = !group.feature || this.preferenceService.hasAccess(group.feature) || (group.feature === "components.mywidgets" && this.projectService.isPrism());
      if (hasAccess_group) {
        group.subGroups = group.subGroups.filter((subGroup: any) => {
          let hasAccess_subGroup = !subGroup.feature || this.preferenceService.hasAccess(subGroup.feature);

          if (hasAccess_subGroup) {
            subGroup.widgets = subGroup.widgets.filter((widget: any) => {
              widget.searchName = this.locale[widget.namekey];
              return !widget.feature || this.preferenceService.hasAccess(widget.feature);
            });
            subGroup.filteredWidgets = subGroup.widgets;
          }
          return hasAccess_subGroup;

        });
      }
      return hasAccess_group;

    });
  }



  showProperties() {
    if (this.activeWidget) {
      return (this.activeWidget.lock === undefined) ? true : this.activeWidget.lock;
    }
    return true;
  };



  initPropertyGroups(isAdvanced?: boolean) {
    let groups = isAdvanced ? PropertiesFactory.getAdvancedPropertyGroups() : PropertiesFactory.getPropertyGroups(),
      mainGroup: any = [],
      map: any = {};
    groups.forEach((group: any) => {
      if (group.platforms && !includes(group.platforms, this.project.platformType)) {
        return;
      }
      if (!group.parent) {
        map[group.name] = [];
        group.show = !group.feature || this.preferenceService.hasAccess(group.feature);
        mainGroup.push(group);
        group.subGroups = map[group.name];
      } else {
        map[group.parent].push(group);
      }
    });
    if (isAdvanced) {
      this.advancedPropertyGroup = mainGroup;
    } else {
      this.propertyGroups = mainGroup;
    }
    mainGroup.forEach((group: any) => {
      if (!group.subGroups.filteredProps) {
        this.filterProperties(group)
      }
    })
  }


  getActiveWidgetPropData(prop: string) {
    return get(this.activeWidget?.widgetProps, prop);
  }

  getMaxLength(property: string) {
    let propertyVal = get(this.activeWidget?.widgetProps, property);
    if (propertyVal?.maxlength == undefined) {
      // TODO: add the max length supported
      return 524288;
    }
    return propertyVal?.maxlength;
  }

  shadowProperty(prop: string) {
    return get(this.shadowProperties, 'name');
  }

  booleanCount() {
    this.boolCount += 1;
    return '_wms_toggle' + this.boolCount;
  }

  setActiveProperty(property: string) {

  }

  isValidDate(value: string) {
    return new Date(value).getTime();
  }

  setFontStyle(property: string, newVal: any, isSelected: boolean) {
    if (isSelected) {
      this.shadowPropertyChange(property, newVal);
    } else {
      this.shadowPropertyChange(property, '');
    }
  }

  shadowPropertyChange(property: string, newValue: any, valueType?: string, calledfunction?: string, isClearProperty?: boolean, isVariableEvt?: boolean) {
    if (!this.activeWidget) {
      let $el = this.markupManager.getActiveCanvasEl();
      if ($el?.length) {
        this.activeWidget = get($el[0], 'widget');
      }
    }
    let activeProperty = get(this.activeWidget, property);

    let checkproperty,
      _width,
      oldValue = activeProperty,
      newValues,
      oldValues: Array<any> = [],
      showInDeviceValues,
      cols,
      errMsgDesc,
      pattern,
      nameRegEx,
      widgetProps,
      widgetType;

    /* Return if activewidget is not defined */
    if (this.activeWidget) {
      widgetProps = this.activeWidget.widgetProps;
      widgetType = this.activeWidget.widgetType;
    } else {
      return;
    }

    if (widgetType === 'wm-tabpane' && property === 'iconclass') {
      property = 'paneicon'
    }


    /*if there is no change in the values, ignore the change request and remove the error icon*/
    if (!isClearProperty && newValue === activeProperty) {
      let prop = get(widgetProps, property);
      if (prop) {
        prop['error'] = false;
      }
      return;
    }
    /*Some Properties are bypassing undo, to set workspace dirty set a flag and refer it in isWorkspaceDirty function*/
    this.widgetPropertyChanged = true;
    this.pageWsService.setWidgetPropertyChangedFlg(true)

    // TODO: this is not avaiable just check and remove
    // $rootScope.$emit('wms:canvas-widget-property-change');

    if (property === "showindevice") {
      oldValue = activeProperty;
      if (isArray(oldValue)) {
        oldValue = join(oldValue, ',');
      }
      if (isArray(newValue)) {
        newValue = join(newValue, ',');
      }
      oldValues = oldValue ? oldValue.split(',') : oldValue;
      newValues = newValue ? newValue.split(',') : newValue;
      //if 'all' is selected remove the other selected options and if newValues length is 1 then do not perform anything
      if (includes(newValue, 'all') && newValues.length > 1) {
        showInDeviceValues = remove(newValues, function (val) {
          return !includes(oldValues, val);
        });
        newValue = showInDeviceValues[0];
      }
    } else if (property === 'layout' && widgetType === 'wm-form') {
      cols = 1;
      set(this.activeWidget, 'formClassName', "form-" + newValue);
      if (newValue === "inline") {
        cols = 4;
      } else {
        // cols = this.activeWidget.layoutObj[newValue];
      }
      if (newValue && activeProperty !== newValue) {
        // TODO: this is not avaiable just check and remove
        // $rootScope.$emit("wmform-template-modified", {"widgetName": this.activeWidget.name, "type": newValue, "forceUpdate": true, "columns": cols});
      }
    } else if (property === 'Javascript') {
      runtimeEventManager.emit('navigateToScript', this.activeWidget);
    }
    if (widgetType === "wm-table") {
      // Do not allow width greater than 100% or 'auto' for grids.
      if (property === "width") {
        _width = parseInt(newValue, 10);
        if (_width > 100 && newValue.indexOf("%") !== -1) {
          return;
        }
      }
    } else if (get(this.activeWidget, "page-container") && property === "content" && newValue) {
      /* if the content for the page-container is set to a page, then remove the existing content */
      this.activeMarkupEl?.empty();
    } else if (property === 'limitdisplaytext' && (widgetType === 'wm-textarea' || widgetType === 'wm-form-field')) {
      newValue = _replace(newValue, this.activeWidget);
    }

    /* name MUST be unique in the application, if the name updated through property panel is not unique, do not process it.*/
    if (property === "name") {
      // TODO: emit the name-change event and handle it
      if (!this.isValidName(newValue)) {
        /* if the provided name is not unique, update the property panel with the old value and return */
        set(this.shadowProperties, property, this.activeWidget[property]);
        if (widgetProps[property]) {
          widgetProps[property].error = false;
        }
        return;
      } else {
        // assign the widgetName i.e. oldVal on nameIdMap to newVal
        nameIdMap[newValue] = nameIdMap[oldValue];
        delete nameIdMap[oldValue];
      }
    }

    // TODO: show hide the hidden overlays
    // if(property === "show" && $rootScope.showHiddenElements){
    //   $scope.handleHideAndShowOverlay(!newValue,this.activeWidget.$element,this.activeWidget.widgettype);
    // }

    /* if there is a pattern property defined, check for that pattern*/
    pattern = (widgetProps[property]) ? widgetProps[property].pattern : undefined;
    if (pattern && calledfunction !== 'variablebinding') {
      nameRegEx = new RegExp(pattern);
      /*Change null to empty string, so that regular expression can be checked*/
      newValue = (newValue === null) ? '' : newValue;
      if (!nameRegEx.test(newValue)) {
        errMsgDesc = "MESSAGE_ERROR_INVALID_INPUT_DESC";
        widgetProps[property].error = true;
        widgetProps[property].errMsgDesc = this.locale[errMsgDesc];
        return;
      }
      widgetProps[property].error = false;
    }

    checkproperty = (widgetProps[property] && widgetProps[property].bindable) ? "bind" + property : property;

    if (this.activeWidget && this.activeWidget[checkproperty] !== newValue) {
      if (newValue === undefined || (get(widgetProps, [property, 'type']) === 'number' && newValue === null)) {
        newValue = "";
      }
      /* if binding done with grid/live-grid's 'dataset', set the newColumnsnewColumns flag */
      if ($.inArray(widgetType, datasetWidgets) !== -1 && property === 'dataset') {
        this.activeWidget.newcolumns = true;
      }
      /* if binding done with listtemplate's 'type', set the newColumns flag */
      if ((widgetType === 'wm-listtemplate' && property === 'layout')) {
        this.activeWidget.newcolumns = true;
      }
      /* Update newcolumns flag on panel's scope when actions property is changed*/
      if (widgetType === 'wm-panel' && property === 'actions') {
        this.activeWidget.newcolumns = true;
      }
      /* update newcolumns flag on liveform's scope when layout property is changed */
      if ((widgetType === 'wm-liveform' || widgetType === 'wm-livefilter') && property === 'layout') {
        this.activeWidget.newcolumns = true;
      }
      /* update newcolumns flag on liveform's scope when layout property is changed */
      if ((this.activeWidget['page-container']) && property === 'content') {
        this.activeWidget.newcolumns = true;
      }

      if (this.isDateProperty(widgetType, checkproperty)) {
        if (newValue && !this.isValidDate(newValue)) {
          widgetProps[property].error = true;
          widgetProps[property].errMsgDesc = this.locale.MESSAGE_ERROR_INVALID_INPUT_DATE;
          return;
        }
        widgetProps[property].error = false;
      }

      /*if variable is binding */
      if (calledfunction === 'variablebinding') {
        if (valueType !== 'resource') {
          this.activeWidget["bind" + property] = newValue;
          if (newValue === "") {
            /*If binding is removed for boolean properties, set the property to true*/
            if (widgetProps[property].type === 'boolean') {
              newValue = true;
            }
            this.activeWidget[property] = newValue;
          }
          if (property === 'disabled') {
            this.activeMarkupEl && (this.activeMarkupEl[0] as HTMLElement).setAttribute(property, newValue);
          } else {
            this.activeMarkupEl?.attr(property, newValue);
          }
        } else {
          this.activeWidget[property] = newValue;
          this.activeMarkupEl?.attr(property, newValue);
          this.activeWidget["bind" + property] = undefined;
        }
        set(this.shadowProperties, property, newValue);

        /*special case for show*/
        if (property === 'show' && newValue === "") {
          this.activeWidget[property] = true;
          this.activeMarkupEl && (this.activeMarkupEl[0] as HTMLElement).setAttribute(property, 'true');
          set(this.shadowProperties, property, true);
        }

        this.propertyChange(property, newValue);
      } else if (calledfunction === 'undo' || calledfunction === 'redo') {/*if the function is called within undo or redo the change should not be updated through wmCommand*/
        this.activeWidget["bind" + property] = undefined;
        set(this.shadowProperties, property, newValue);
        this.activeWidget[property] = newValue;
        if (property === 'disabled') {
          this.activeMarkupEl && (this.activeMarkupEl[0] as HTMLElement).setAttribute(property, newValue);
        } else {
          this.activeMarkupEl?.attr(property, newValue);
        }
        property = property.replace('on-', 'on');
        if (this.isEventTypeProperty(property)) {
          this.setEventHandlerExpr(property, newValue);
        }
      } else {/*when property changes */
        set(this.shadowProperties, property, newValue);
        this.propertyChange(property, newValue);
        this.updateStateOfHiddenEle();
      }

    }

    if (widgetType === 'wm-gridcolumn' && property === 'columnwidth') {
      newValue = parseInt(newValue, 10);
      oldValue = parseInt(oldValue, 10);
      //Extract only direct columns, there might be another layout grid dropped inside same column
      let columns = this.activeMarkupEl?.parent().find('> wm-gridcolumn'),
        activeWidgetId = this.activeMarkupEl?.attr('widgetid'),
        tolWidth = 0,
        diff = newValue > oldValue ? newValue - oldValue : oldValue - newValue,
        siblingEle: any,
        siblingWidth,
        siblingIs: any,
        curCol,
        sibling: any;
      forEach(columns, (column, index) => {
        curCol = $(column);
        if (activeWidgetId === curCol.attr('widgetid')) {
          tolWidth += newValue;
          //If cur column is activeWidget and it is last ele sibling ele is prev element else sibling will be next element
          if (columns && index === columns.length - 1) {
            siblingEle = columns.eq(index - 1);
          } else {
            siblingEle = columns?.eq(index + 1);
          }
        } else {
          tolWidth += parseInt(curCol?.attr('columnwidth') || '', 10);
        }
      });

      //If there is only 1 column just decrease/increase to selected width
      if (columns && columns.length > 1) {
        siblingWidth = parseInt(siblingEle.attr('columnwidth'), 10);
        sibling = $('[widgetid = ' + siblingEle.attr('widgetid') + ']')[0];
        siblingIs = sibling.widget;
        //If tolal width is = 12 then don't change sibling elements width
        if (tolWidth !== 12) {
          //If tolWidth with newValue is greater than 12 the prev child width will reduce by the increased width of active column
          if (tolWidth > 12) {
            if ((siblingWidth - diff) > 0) {
              siblingIs.columnwidth = siblingWidth - diff;
            } else { // If sibling cant accommodate the width diff revert the value to old value
              this.activeWidget.columnwidth = oldValue;
              runtimeEventManager.emit('set-markup-attr', { widgetId: activeWidgetId, 'columnwidth': this.activeWidget.columnwidth });
              return;
            }
            siblingIs.columnwidth = (siblingWidth > diff ? siblingWidth - diff : diff - siblingWidth).toString();
          } else { // Else the increased width will be added to the next child
            siblingIs.columnwidth = (siblingWidth + diff).toString();
          }
          runtimeEventManager.emit('set-markup-attr', { widgetId: siblingEle.attr('widgetid'), 'columnwidth': siblingIs.columnwidth });
        }
      }
    }
    else if (widgetType === 'wm-container') {

      if (property === 'wrap' && newValue) {

        const columngap = get(this.shadowProperties, 'columngap') || '4';

        this.activeMarkupEl?.attr('columngap', columngap)
        this.setAutoLayoutAlignmentIcon(columngap)

        set(this.shadowProperties, 'columngap', columngap);
        this.propertyChange('columngap', columngap);

      } else if ((property === 'wrap' && !newValue) || property === 'direction') {
        const gap = get(this.shadowProperties, 'columngap') || 4;
        this.activeMarkupEl?.removeAttr('columngap')

        this.activeMarkupEl?.attr('gap', gap)

        this.setAutoLayoutAlignmentIcon(gap)
        set(this.shadowProperties, 'gap', gap);
        this.propertyChange('gap', gap);
      }
      if (property === 'direction' && newValue === 'column') {
        set(this.shadowProperties, 'wrap', false);
        this.propertyChange('wrap', false);
      }
      if ((property === 'gap' || property === 'columngap')) {
        this.setAutoLayoutAlignmentIcon(newValue)
      }

      if(property === 'position') {
        if(newValue === 'relative') {
          this.activeMarkupEl?.removeAttr('zindex');
        } else {
          set(this.shadowProperties, 'zindex', '1');
          this.propertyChange('zindex', '1');
        }
      }

      if(property === 'clipcontent') {
        if(newValue === false) {
          this.activeMarkupEl?.removeAttr('overflow');
        } else {
          set(this.shadowProperties, 'overflow', 'No scrolling');
          this.propertyChange('overflow', 'No scrolling');
        }
      }

      if((property === 'height' || property === 'width')) {
        if(newValue === 'hug' && get(this.shadowProperties, property === 'height' ? 'width' : 'height') === 'hug') {
          this.activeMarkupEl?.removeAttr('clipcontent');
          this.activeMarkupEl?.removeAttr('overflow');
          set(this.shadowProperties, 'clipcontent', false);
          set(this.shadowProperties, 'overflow', 'No scrolling');
          this.propertyChange('clipcontent', false);
          this.propertyChange('overflow', 'No scrolling');
        } else {
          this.propertyChange('clipcontent', get(this.shadowProperties, 'clipcontent') || false);
          if(get(this.shadowProperties, 'clipcontent')) {
            set(this.shadowProperties, 'overflow', 'No scrolling');
            this.propertyChange('overflow', 'No scrolling');
          }
        }
      }

      runtimeEventManager.emit('wms:refresh-properties-panel');
    }
    if (this.activeWidget) {
      this.activeWidget.updateOnpropChange && this.activeWidget?.updateOnpropChange(property);
    }
  };

  updateStateOfHiddenEle() {
    let markup, hiddenEleLength;
    markup = this.markupManager.getMarkup();
    hiddenEleLength = markup?.find("[show='false']").length;
    this.hiddenElementsExist = !!(hiddenEleLength && hiddenEleLength > 0);
    this.pageWsService.hiddenElementsExist = !!(hiddenEleLength && hiddenEleLength > 0);
  }

  /*This function sets the value of the given widget event in the widgets' properties panel*/
  setEventHandlerExpr(property: string, value: any) {
    let el = $("[event-name=" + property + "]")[0];
    let scope = get(el, 'widget');
    if (scope) {
      set(scope, 'eventExpr', value);
    }
  }



  setAndPropertyChange(property: string, optVal: string) {
    set(this.shadowProperties, property, optVal);
    this.shadowPropertyChange(property, get(this.shadowProperties, property));
  }

  openIconChooserDialog(widgetProperty: any, propertyName: string) {
    this.dialogService.open('selectIconDialog');
    this.iconBoundToProperty = propertyName;
  }

  filterPropertyByKey(searchKey: string, propertyGroup: any): void {
    let regEx = new RegExp(searchKey, 'i');
    propertyGroup.subGroups = propertyGroup?.subGroups?.map((subGroup: any) => {
      subGroup.filteredProps = subGroup?.properties?.filter((filteredProp: any) => {
        let config = this.activeWidget?.widgetProps && get(this.activeWidget.widgetProps, filteredProp);
        return regEx.test(filteredProp) || (config && (regEx.test(config.displayName) || regEx.test(this.locale[config.displayKey]) || regEx.test(config.label) || regEx.test(this.locale['LABEL_PROPERTY_' + filteredProp.toUpperCase()])));
      });
      return subGroup;
    });
    this.group = propertyGroup;
  }

  isEventTypeProperty(name: string) {
    let widgetProps = this.activeWidget.widgetProps;

    if (!widgetProps) {
      return false;
    }

    if (widgetProps[name] && (widgetProps[name].type === 'event' || widgetProps[name].isGroupBy)) {
      return true;
    }
    return false;
  }

  /* on select of property tab in the property panel */
  onPropertyGroupTabSelect(tabGroup: any) {
    // this.setActiveProperty({});
    /* send call to backend, to check whether security is enabled or not*/
    if(tabGroup) {
      updateUrlParams([{key: "p", value: tabGroup.name}], this.router, this.route);
    }
    if (tabGroup && tabGroup.name === "security") {
      /* get general options*/
      (this.securityService.getAuthInfo() as Promise<any>).then((options) => {
        this.liveWidgetSettingsService.isSecurityEnabled = options.enforceSecurity;
        if (this.liveWidgetSettingsService.isSecurityEnabled) {
          /* initialize roles only when secutiry is enabled. */
          this.getSecurityRoles();
        }
      });
    }
  }

  /* function to initialize roles */
  getSecurityRoles() {
    (this.securityService.getRolesConfig() as Promise<any>).then((configroles) => {
      this.securityService._rolesConfig = configroles;
      let roles: any = [];
      if (Array.isArray(configroles)) {
        configroles.map((role) => {
          roles.push(role.name);
        });
        if (!isEqual(this.liveWidgetSettingsService.accessroles, roles)) {
          this.liveWidgetSettingsService.accessroles = roles;
        }
        PropertiesFactory.setRoles(roles);
      }
    });
  }

  propertyChange(id: string, newVal: any) {
    let oldVal,
      widgetName = this.activeWidget.name,
      widgetType = this.activeWidget.widgetType,
      widgetId = this.activeWidget.widgetId,
      prefix,
      varDetails,
      args,
      evt = id,
      events,
      eventNumber,
      name = id, $containerEle, $headerEle,
      $activeEle = this.activeWidget.$element;
    const eventName = name;

    /*updating the old value in activeWidget scope*/
    if (this.isEventTypeProperty(name)) {
      name = name.replace("on", "on-");
      /*For events, values are stored in __onEvent. Fetch variables from this variable*/
      this.activeWidget['old-' + name] = this.activeWidget[name.replace('on-', '__on')];
    } else {
      this.activeWidget['old-' + name] = this.activeWidget[name];
    }
    oldVal = this.activeWidget['old-' + name];

    // TODO: added the below condition to set isGroupBy to true. move this to other file when working on groupby
    if (name == 'groupby' && newVal && newVal !== '' && newVal == 'Javascript') {
      this.activeWidget.widgetProps[name].isGroupBy = true;
    }
    if (name === 'margin' || name === 'padding' || name === 'borderwidth') {
      this.setMarginAndPadding(name, newVal);
    }

    /* if the property is show, according to the current toggle condition(ie, show/hide hidden elements),
     ng-hide class gets updated to the widget elements.
     */
    if (id === "show") {

      if (widgetType === "wm-wizardstep") {
        // $headerEle = $($activeEle.isolateScope()._headerElement);
        let stepId = $activeEle[0].widget.widgetId;
        let $headerEle = $activeEle[0].widget._viewParent.$element.find('[data-wizardstepid="' + stepId +'"]');

        $containerEle = (widgetType === "wm-wizardstep") ? ($headerEle.find('>a')) : ($headerEle);
        if (newVal) {
          $containerEle.removeClass(HIDE_WIDGET_CLASS);
        } else {
          this.toggleClass($activeEle, HIDE_WIDGET_CLASS);
          this.toggleClass($containerEle, HIDE_WIDGET_CLASS);
        }
      }
    }

     if(id === 'pagesizeoptions'){
        const  updatedPagesizeoptions =  this.pageWsService.validatePageSizeOptions(newVal)
        newVal = updatedPagesizeoptions;
        set(this.shadowProperties, id, updatedPagesizeoptions);
        this.activeWidget[id] = updatedPagesizeoptions
    }

    // TODO: handle the events of the widget
    /* handling the events of widgets */
    if (this.isEventTypeProperty(id)) {
      id = id.replace("on", "on-");
      if (includes(newVal, WIDGET_CONSTANTS.EVENTS.JAVASCRIPT)) {
        prefix = widgetName + id.replace("on-", "");
        events = newVal && newVal.split(';');
        if (isArray(events)) {
          events = events.map(function (event) {
            return event.indexOf('(') > -1 && event.substring(0, event.indexOf('('));
          });
          if (events && events.indexOf(prefix) !== -1) {
            eventNumber = 1;
            while (events.indexOf(prefix + eventNumber) !== -1) {
              eventNumber += 1;
            }
            prefix = prefix + eventNumber;
          }
        }
        //   /* if the widget type is grid, change the default arguments of that event handler in the markup */
        args = this.pageWs.getListenerArguments(id, widgetType);
        newVal = newVal.replace(WIDGET_CONSTANTS.EVENTS.JAVASCRIPT, prefix + args);
        this.pageWs.eventHandler(id, { 'widgetName': widgetName, 'eventPrefix': prefix });
      }

      // TODO: complete the else part for variables and other types of handlers
      else {
        /* If the event is not a variable handling options like
         * create new service, live variable and navigation variables
         * return since showAddVariableDialog handles setting property as newly created variable*/
        varDetails = StudioUtils.getVariableDetails(newVal);
        // if (varDetails.category) {
        // $scope.showAddVariableDialog(varDetails.type, {
        //   'mode'         : 'CREATEONLY',
        //   'source'       : 'widget',
        //   'category'     : varDetails.category,
        //   'trgtEvt'      : evt,
        //   'trgtEvtVal'   : varDetails.evtVal
        // });
        //   return;
        // }
      }
    }
    this.wmCommand.execute(new PropertyController(), this, "updateProperty", { "property": id, "value": newVal, "oldValue": oldVal });
    this.pageWsService.startAutoSave();
    this.activeWidget[id] = newVal;
    this.activeWidget[eventName] = newVal;
    if(id === "show"){
      //supports to remove hidden attribute of element, in case of showHiddenElements (storage value) is true and show toggle value is false
      if (this.pageWsService.showHiddenElements && !newVal)
      $activeEle.removeAttr(HIDE_WIDGET_CLASS);

      //on properties panel updates, adds hidden-overlay wrapper to widgets on basis of showHiddenElements (storage value)
      this?.pageWsService?.showHiddenElements && this.pageWsService.handleHideAndShowOverlay(!newVal, $activeEle, widgetType, widgetId);
    }
    // on change, assigning event names or fiel vales on fieldDefConfig
    if (this.activeWidget.widgetType === 'wm-form-field') {
      this.activeWidget.fieldDefConfig[eventName] = newVal;
      this.activeWidget[eventName] = newVal;
    }
    if( this.activeWidget.widgetType === 'wm-custom-widget'){
      $invokeWatchers(true);
    }
    this.propertyGroups.forEach((group: any) => {
      if ((group.name === this.locale['LABEL_PROPERTY_STYLES'].toLowerCase() && group.active) || id === 'padding') {
        setTimeout(() => {
          this.canvasDomService.updateFocusNodePos();
        });
      }
    });
  };

  setMarginAndPadding(name: string, newVal: string) {
    let propertyValues = [];
    let suffix = ''
    if (name === 'borderwidth') {
      suffix = 'width'
      name = 'border'
    }
    propertyValues = newVal.split(" ");
    let top, bottom, left, right = '';
    propertyValues = propertyValues.map(value => value === 'unset' ? '' : value);
    if (propertyValues.length == 2) {
      top = bottom = propertyValues[0];
      left = right = propertyValues[1];
    } else if (propertyValues.length == 1) {
      top = right = bottom = left = propertyValues[0];
    } else {
      [top, right, bottom, left] = propertyValues;
    }
    this.activeWidget[name + 'top' + suffix] = top;
    this.activeWidget[name + 'bottom' + suffix] = bottom;
    this.activeWidget[name + 'right' + suffix] = right;
    this.activeWidget[name + 'left' + suffix] = left;
  }

  isDateProperty(widgetType: string, property: any) {
    return (widgetType === 'wm-date' || widgetType === 'wm-datetime') && (property === "datavalue" || property === "mindate" || property === "maxdate");
  }

  toggleClass(element: JQuery<HTMLElement>, className: string) {
    if (this.pageWsService.showHiddenElements === false) {
      $(element).addClass(className);
    } else {
      $(element).removeClass(className);
    }
  }

  setWidgetGroupActive() {
    let widgetPropertyList: any = [];
    if (this.widgetProperties.widgetsList) {
      widgetPropertyList = this.widgetProperties.widgetsList;
    } else {
      widgetPropertyList = this.widgetFactory();
      this.widgetProperties.widgetsList = widgetPropertyList;
    }

    if (!widgetPropertyList.length) {
      return;
    }
    widgetPropertyList[0].open = true;

    if (widgetPropertyList[1]) {
      widgetPropertyList[1].open = false;
    }
    let isMobileApplicationType = this.projectService.isMobileApplicationType();

    const widgetsGroupIndex = widgetPropertyList.findIndex((g: any) => g.name === 'widgets');
     let myWidgetsGroup = isMobileApplicationType ? widgetPropertyList.find((g: any) => g.name === 'WmxWidgets') : null;

    if (widgetsGroupIndex !== -1 && myWidgetsGroup) {
      const mergedSubGroups = [ ...(widgetPropertyList[widgetsGroupIndex].subGroups || []), ...(myWidgetsGroup.subGroups || [])];
      widgetPropertyList[widgetsGroupIndex] = { ...widgetPropertyList[widgetsGroupIndex], subGroups: mergedSubGroups };

      // Filter out the myWidgets group
      const myWidgetsGroupName = isMobileApplicationType ? 'WmxWidgets' : 'Mywidgets';
      widgetPropertyList = widgetPropertyList.filter((g: any) => g.name !== myWidgetsGroupName);
    }
    // Assigning widget groups to shown in the left panel.
    this.pageWs.widgetFactory = this.widgetProperties.widgetsList = widgetPropertyList;
    this.pageWs.filterWidget(widgetPropertyList[0],"")
    this.pageWs.filterPrefab(widgetPropertyList[1],"")

  }

  filterProperties(group?: any, searchKey?: any, widgetprops?: any) {
    let regEx = new RegExp(searchKey, 'i');
    group.subGroups.forEach((subGroup: any) => {
      let isPrism = this.projectService.isPrism();
      if (isPrism && group.name === 'styles') {
        // filter out online properties for prism projects
        const allowedProps = ['class', 'conditionalstyle', "conditionalclass", "variant", "backgroundimage", "backgroundrepeat", "backgroundresizemode", "backgroundposition", "backgroundsize", "backgroundattachment", "listclass", "itemclass", "chipclass"];
        subGroup.properties = subGroup.properties.filter((property: any) =>
          allowedProps.includes(property)
        );
      }
      if (!searchKey) {
        subGroup.filteredProps = subGroup.properties.filter((property: any) => {
          let config = widgetprops && widgetprops[property];
          return regEx.test(property) || (config && (regEx.test(config.displayName) || regEx.test(this.locale[config.displaykey] || regEx.test(config.label) || regEx.test(this.locale['lABEL_PROPERTY_' + property.toUpperCase()]))));
        });
      }
    });

    if (!this.projectService.isPrismWeb()) {
      group.subGroups = group.subGroups.filter((subGroup: any) => subGroup.name !== 'advanceproperty');
    }
  }

  showVariableDialog(pageTitle: string) {
    if (pageTitle.startsWith("bind:Variables.")) {
      let boundEntity = pageTitle.replace("bind:Variables.", ''),
        variableName = boundEntity.slice(0, boundEntity.indexOf('.'));
      forEach((this.baseVariableService.variableCollection), (collection: any) => {
        forEach(collection, (variable: any) => {
          if (variable.name === variableName) {
            this.baseVariableService.selectedVariableView = 'Variables';
            this.varManagerService.initVariablePropertyList();
            let variableObj = cloneDeep(variable);
            this.varManagerService.getTypesOfSelectedVariables(variableObj.category, variableObj);
          }
        })
      });
      this.openDialogWithId("variableModal");
    }
  }


  closeDialogWithId(id: string): void {
    this.dialogService.close(id)
  }

  isValidName(name?: string) {
    let isValid = true;
    let errMsgTitle = '', errMsgDesc = '';

    if (!name) {
      isValid = false;
      errMsgTitle = "MESSAGE_ERROR_INVALID_WIDGETNAME_TITLE";
      errMsgDesc = "MESSAGE_ERROR_INVALID_WIDGETNAME_DESC";
    } else if (nameIdMap[name]) {
      isValid = false;
      errMsgTitle = "MESSAGE_ERROR_DUPLICATE_WIDGETNAME_TITLE";
      errMsgDesc = "MESSAGE_ERROR_DUPLICATE_WIDGETNAME_DESC";
    }

    // name is not valid, show the error message
    if (!isValid) {
      this.notificationService.show("error", get(this.locale, errMsgTitle), get(this.locale, errMsgDesc));
    }
    return isValid;
  }


  onPageTitleChange(title: string) {
    this.activeWidget.pagetitle = title;
    this.activeMarkupEl?.attr('pagetitle', title);
    this.pageWsService.setWidgetPropertyChangedFlg(true);
  }
  openDialogWithId(id: string): void {
    this.dialogService.open(id)
  }
  openBindVariableDialog(widgetProperty: any, propertyName: any, boundContext?: any) {
    this.openDialogWithId("BindVariable");
    let activeTabName,
      boundEntity = widgetProperty.isSubProperty ? widgetProperty.value : (this.activeWidget["bind" + propertyName] || this.activeWidget[propertyName]);
    if (boundContext && !boundEntity) {
      activeTabName = boundContext;
    }
    this.bindVariableService.dialogParams = {
      bindMode: 'widget',
      boundEntity: boundEntity,
      prevBoundEntity: this.bindVariableService.prevBoundEntity,
      activePageName: this.pageWsService.activePageName,
      activeProperty: {
        propertyOwnerName: this.activeWidget.name,
        propertyDetails: widgetProperty,
        name: propertyName,
        widgetId: this.activeWidget.widgetId
      },
      setActiveTabName: activeTabName,
      propertyBindCallback: (boundVariable: any, boundProperty: any, boundVariableType: any) => {
        if (widgetProperty.isSubProperty) {
          widgetProperty.propertyModel.value = boundVariable;
          this.onPartialParamValueChange(this.activeWidget);
        } else {
          this.bindVariableService.prevBoundEntity = boundVariable;
          this.shadowPropertyChange(boundProperty, boundVariable, boundVariableType, "variablebinding");
        }
      }
    }
  }

  openBindVariableDialogForPageTitle() {
    this.openDialogWithId("BindVariable");
    this.bindVariableService.dialogParams = {
      bindMode: 'widget',
      activePageName: this.pageWsService.activePageName,
      boundEntity: this.activeWidget.pagetitle,
      activeProperty: {
        propertyOwnerName: this.activeWidget.name,
        propertyDetails: { 'type': 'string' },
        name: 'pagetitle'
      },
      propertyBindCallback: (boundVariable: any) => {
        this.onPageTitleChange(boundVariable);
      }
    };
  }

  onPartialParamValueChange(widget: any) {
    this.pageWsService.setWidgetPropertyChangedFlg(true);
    this.eventManager.emitPartialParamsChange({ params: widget.partialParams, widgetName: widget.name, content: widget.content });
  };


  /*clear the property value when we click on clear icon in property panel*/
  clearProperty = (property: any) => {
    this.shadowPropertyChange(property, '', '', 'variablebinding', true);
  }

  dialogParams(boundVariable: string, boundProperty: string, boundVariableType: string) {
    console.log(boundVariable, boundProperty, boundVariableType,)
    this.shadowPropertyChange(this.iconBoundToProperty, boundVariable, boundVariableType);
    this.closeDialogWithId('selectIconDialog')
  }

  handleAdvancedSettingsClick = (evt: any) => {
    this.onAdvancedSettingsClick.emit({
      shadowProperties: (this.shadowProperties ? { ...this.shadowProperties } : {}),
      propertyGroups: (this.propertyGroups ? [...this.propertyGroups] : []),
      advancedPropertyGroup: (this.advancedPropertyGroup ? [...this.advancedPropertyGroup] : []),
      activeWidget: this.activeWidget
    })
  }

  setAppPrefabServerProperty() {
    this.prefabService.setAppPrefabServerProps({
      projectID: this.projectService.getProjectId(),
      prefabName: this.activeWidget.prefabName,
      data: this.activeWidget.serverProps
    });
  }

  setAutoLayoutAlignmentIcon(gap: any) {
    const alignment = get(this.shadowProperties, 'alignment') || 'top-left';
    const direction = get(this.shadowProperties, 'direction') || 'row';
    const isWrap = direction === 'row' ? get(this.shadowProperties, 'wrap') || false : false;
    const columnGap = toBoolean(isWrap) ? get(this.shadowProperties, 'columngap') : null;

    let useAutoAlignment = !toBoolean(isWrap) ? gap === 'auto' : columnGap === 'auto';

    if (!useAutoAlignment ) {
      const alignmentMap: Record<string, string> = { start: 'top-left', center: 'middle-left', end: 'bottom-left' };
      if (["start", "center", "end"].includes(alignment)) {
        set(this.shadowProperties, 'alignment', alignmentMap[alignment]);
        this.propertyChange('alignment', alignmentMap[alignment] || alignment);
      }
    } else {
      const [row] = alignment.split('-');
      const alignmentMap: Record<string, string> = {
        top: 'start',
        middle: 'center',
        bottom: 'end'
      };
      set(this.shadowProperties, 'alignment', alignmentMap[row] || alignment);
      this.propertyChange('alignment', alignmentMap[row] || alignment);
    }
  }

  applyAutoLayout() {
    runtimeEventManager.emit('add-autolayout');
  }

}
